import { render, staticRenderFns } from "./SignatureStats.vue?vue&type=template&id=e5772b60&scoped=true"
import script from "./SignatureStats.vue?vue&type=script&lang=js"
export * from "./SignatureStats.vue?vue&type=script&lang=js"
import style0 from "./SignatureStats.vue?vue&type=style&index=0&id=e5772b60&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5772b60",
  null
  
)

export default component.exports